if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /* google tagmanager input
        * 
        * */
        ZZ.GtmTouchpointInput = function(GtmTouchpointInputContainer) {
            var base = this;
            base.container = GtmTouchpointInputContainer;
            base.datalayerData = jQuery.parseJSON(
                base.container.attr("data-gtm-datalayer")
            );
            base._eventsToBind = base.container.attr("data-gtm-event");

            base.assignListeners();
        };

        ZZ.GtmTouchpointInput.prototype = {
            /*assignListeners: function () {
            var base = this;

            base.gtmTouchpoint.removeListeners();

            base.gtmTouchpoint.pushData = function () {
            base.appendTodatalayerData(base.container.attr('data-gtm-fieldname'), base.container.val())
            };

            //base.gtmTouchpoint.assignListeners();

            },*/
            assignListeners: function() {
                var base = this;

                if (
                    base._eventsToBind !== "" &&
                    base._eventsToBind !== undefined
                ) {
                    base._eventsToBind = base._eventsToBind.replace(
                        /[`~!@#$%^&*()_|+\-=?;:'" .<>\{\}\[\]\\\/]/gi,
                        ""
                    );
                    base._eventsToBind = base._eventsToBind.split(",");

                    for (
                        var i = 0, len = base._eventsToBind.length;
                        i < len;
                        i++
                    ) {
                        base.container.on(
                            base._eventsToBind[i],
                            base.appendTodatalayerData.bind(base)
                        );
                    }
                } else {
                    base.container.on(
                        "click",
                        base.appendTodatalayerData.bind(this)
                    );
                }
            },

            appendTodatalayerData: function() {
                var property = this.container.attr("data-gtm-fieldname");
                var data = this.container.val();

                if (this.datalayerData !== null) {
                    var oldData = this.datalayerData["events"]["label"];
                    this.datalayerData["events"]["label"] =
                        oldData + "," + data;
                    this.pushData();
                }
            },

            pushData: function() {
                if (window["dataLayer"]) {
                    window["dataLayer"].push(this.datalayerData);
                }
            }
        };
    })(jQuery);
} else {
    (function() {
        "use strict";

        /**
         * google tagmanager input, implemented with VanillaJS
         *
         */
        ZZ.GtmTouchpointInput = function(GtmTouchpointInputContainer) {
            var base = this;
            base.container = GtmTouchpointInputContainer;
            base.datalayerData = JSON.parse(
                base.container.getAttribute("data-gtm-datalayer")
            );
            base._eventsToBind = base.container.getAttribute("data-gtm-event");

            base.assignListeners();
        };

        ZZ.GtmTouchpointInput.prototype = {
            assignListeners: function() {
                var base = this;

                if (
                    base._eventsToBind !== undefined &&
                    base._eventsToBind !== null &&
                    base._eventsToBind !== ""
                ) {
                    base._eventsToBind = base._eventsToBind.replace(
                        /[`~!@#$%^&*()_|+\-=?;:'" .<>\{\}\[\]\\\/]/gi,
                        ""
                    );
                    base._eventsToBind = base._eventsToBind.split(",");

                    for (
                        var i = 0, len = base._eventsToBind.length;
                        i < len;
                        i++
                    ) {
                        base.container.addEventListener(
                            base._eventsToBind[i],
                            base.appendTodatalayerData.bind(base)
                        );
                    }
                } else {
                    base.container.addEventListener(
                        "click",
                        base.appendTodatalayerData.bind(this)
                    );
                }
            },

            appendTodatalayerData: function() {
                var property = this.container.getAttribute(
                    "data-gtm-fieldname"
                );
                var data = this.container.value;

                if (this.datalayerData !== null) {
                    var oldData = this.datalayerData["events"]["label"];
                    this.datalayerData["events"]["label"] =
                        oldData + "," + data;
                    this.pushData();
                }
            },

            pushData: function() {
                if (window["dataLayer"]) {
                    window["dataLayer"].push(this.datalayerData);
                }
            }
        };
    })();
}
